import React from "react";

export function BrandLogo({ light = false, size = "md" }) {
  const sizes = { sm: "text-lg", md: "text-xl", lg: "text-2xl" };
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className={`grid h-9 w-9 place-items-center rounded-xl font-display font-extrabold text-white shadow-sm ${light ? "bg-white/15 backdrop-blur" : "bg-gradient-to-br from-blue-700 to-blue-500"}`}>
        A
        <span className="absolute -mt-4 ml-5 h-2 w-2 rounded-full bg-orange-500" />
      </div>
      <div className="leading-none">
        <div className={`font-display font-extrabold tracking-tight ${sizes[size]} ${light ? "text-white" : "text-slate-900"}`}>
          ACOMPANHA
        </div>
        <div className={`text-[9px] font-semibold uppercase tracking-[0.15em] ${light ? "text-blue-100" : "text-slate-400"}`}>
          Acompanhamento Escolar
        </div>
      </div>
    </div>
  );
}
